/**
 * Вход в админ-панель — admin.lovirds.ru.
 * Тот же дизайн-кит, что у остальных экранов входа, но одна колонка и без
 * рекламных обещаний: это внутренний инструмент.
 */
import { useEffect, useState } from "react";
import { useNavigate } from "react-router";
import { motion } from "framer-motion";

import { APIAdminLogin } from "../../api_admin_auth";
import { useAdmin } from "../../AdminContext";
import {
    AuthBackground, Wordmark, Field, PrimaryButton, Notice, PasswordToggle,
    IconMail, IconLock, IconShield,
} from "../../components/Auth/ui";
import "../../components/Auth/cabinet.css";

export default function AdminLoginPage() {
    const navigate = useNavigate();
    const { applyLoginSuccess, authStatus } = useAdmin();

    const [email, setEmail] = useState("");
    const [password, setPassword] = useState("");
    const [showPw, setShowPw] = useState(false);
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState(null);

    useEffect(() => {
        if (authStatus === "authed") navigate("/admin", { replace: true });
    }, [authStatus, navigate]);

    const submit = async (e) => {
        e?.preventDefault();
        setError(null);
        if (!email.trim() || !password) { setError("Введите email и пароль"); return; }
        setLoading(true);
        try {
            const r = await APIAdminLogin({ email: email.trim(), password });
            await applyLoginSuccess({ token: r.token, admin: r.admin });
            navigate("/admin");
        } catch (err) {
            setError(err?.response?.data?.error || "Не удалось войти. Проверьте почту и пароль");
            setLoading(false);
        }
    };

    return (
        <AuthBackground variant="pro">
            <div className="lv-pro lv-pro--solo">
                <div className="lv-pro__inner">
                    <motion.div className="lv-pro__head"
                                initial={{ opacity: 0, y: -12 }} animate={{ opacity: 1, y: 0 }}
                                transition={{ duration: 0.4 }}>
                        <span className="lv-pro__mark"><IconShield /></span>
                        <div>
                            <Wordmark size="sm" />
                            <div className="lv-pro__kicker">админ-панель</div>
                        </div>
                    </motion.div>

                    <motion.form className="lv-pro__panel" onSubmit={submit} noValidate
                                 initial={{ opacity: 0, y: 24, scale: 0.98 }} animate={{ opacity: 1, y: 0, scale: 1 }}
                                 transition={{ delay: 0.08, type: "spring", stiffness: 260, damping: 26 }}>
                        <h2 className="lv-pro__title">Вход для сотрудников</h2>

                        {error ? <Notice tone="error">{error}</Notice> : null}

                        <Field icon={<IconMail />} type="email" inputMode="email" autoComplete="email"
                               placeholder="admin@lovirds.ru" value={email} enterKeyHint="next"
                               onChange={(e) => setEmail(e.target.value)} />

                        <Field icon={<IconLock />} type={showPw ? "text" : "password"} autoComplete="current-password"
                               placeholder="Пароль" value={password} enterKeyHint="go"
                               onChange={(e) => setPassword(e.target.value)}
                               end={<PasswordToggle shown={showPw} onToggle={() => setShowPw((s) => !s)} />} />

                        <PrimaryButton type="submit" loading={loading}>
                            {loading ? "Входим…" : "Войти"}
                        </PrimaryButton>

                        <div className="lv-pro__note">
                            <IconLock />
                            <span>Доступ только для сотрудников. Все действия в панели пишутся в журнал.</span>
                        </div>
                    </motion.form>
                </div>
            </div>
        </AuthBackground>
    );
}
